//
//
//

import Vue from 'vue'
export default {

	mounted(){
		if(this.$route.query.tk){
			let redirect_path = this.$route.query.p || Vue.localStorage.get('referer') || '/'
			this.$store.commit('setWxToken',{openid:this.$route.query.tk})
			this.$router.replace({path:redirect_path})
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/wxtoken.vue